var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop, PropSync, Watch } from 'vue-property-decorator';
import InfosetExportTabs from '@/modules/infosets/components/ExternalExportations/InfosetExportTabs.vue';
import InfosetExportProgressContainer from '@/modules/infosets/containers/Exportations/InfosetExportProgress.container.vue';
import Header from '@/modules/infosets/components/Exportations/InfosetExportHeader.vue';
import InfosetExportContentComponent from '@/modules/infosets/components/Exportations/InfosetExportContent.vue';
import Modal from 'components/Modal.vue';
import { exceedLimit } from '@/shared/utils/Infosets.utils';
import InnerLoading from '@/components/InnerLoading.vue';
import Tooltip from 'components/Tooltip.vue';
import { connect } from '@/overmind';
import { mixpanelTracking } from '@/services/mixpanel';
import { NotificationService } from '@/services/NotificationService';
let InfosetExportModalContainer = class InfosetExportModalContainer extends Vue {
    constructor() {
        super(...arguments);
        this.loadedExportationsInProgress = false;
        this.warningTotvsMsg = 'Atenção! Antes de exportar sua lista, verifique se a opção de atualizar dados das oportunidades está de acordo. Caso não precise atualizar os dados, então basta clicar em exportar. Se precisar atualizar, basta habilitar a opção de <b>Atualizar dados... </b> e em seguida clique em exportar.';
        this.buttonLoading = false;
        this.calculatingCount = 0;
        this.tab = '';
        this.thumbStyleScrool = {
            right: '2px',
            borderRadius: '5px',
            backgroundColor: '#CFD8DC',
            width: '5px',
            opacity: 0.75,
        };
        this.exportedCnpjForMeetime = 0;
        this.hasLoading = {};
        this.decisorsFilter = true;
        // InfosetExportContent properties
        this.loaded = false;
        this.companiesCNPJsTotvsExists = [];
        this.updateTotvsData = false;
        this.keepRedundancy = false;
        this.service = 'excel';
        this.exportType = 'companies';
        this.fields = {};
        this.filters = {
            companiesSuccessStatus: false,
            levels: [],
            departments: [],
            decisors: true,
            decisors_with: [],
            unique_decisors_only: false,
        };
        this.saveFiltersAndFields = false;
        this.disabledToggleSaveFiltersAndFields = false;
        this.cadenceApiUrl = '';
        this.ownerSelected = {};
        this.onlyValidPhones = false;
        this.piperunDealConfig = null;
        this.meetimeCadenceConfig = null;
        this.bitrixDealConfig = null;
        this.saveTimeout = null;
        this.loadingWaitingComplete = false;
        this.loadingPercentageCompleted = false;
    }
    handleMsgExceedLimit(tab) {
        const handleLimit = tab == 'excel'
            ? '100.000 linhas'
            : tab == 'agendor'
                ? '1.500 registros'
                : '10.000 registros';
        return `A quantidade de empresas ou decisores excedeu o limite de ${handleLimit}. Que tal aumentar os critérios da sua busca?`;
    }
    loadingWaitingStatus(status) {
        this.loadingWaitingComplete = !status;
    }
    loadingCompleted(value) {
        this.loadingPercentageCompleted = value;
    }
    async mounted() {
        this.handleMixpanelTracking('exportação externa: Abriu exportação CRM');
        //@ts-ignore
        const accountId = await this.users.getAccountId();
        //@ts-ignore
        const result = await this.actions.getInfosetExportationsInProgress({
            accountId: accountId,
            infosetId: this.infoset.id,
        });
        if (result) {
            result.map(el => {
                const service = el.params.service.split('-')[0];
                this.hasLoading[service] = el._id;
            });
            this.loadedExportationsInProgress = true;
        }
        //@ts-ignore
        const response = await this.users.recoverExportationFieldsAndFilters();
        if (response) {
            this.saveFiltersAndFields = true;
            this.tab = response.selected_tab;
            this.service = response.selected_service;
            this.fields = response.selected_fields;
            if ('only_valid_phones' in response)
                this.onlyValidPhones = response.only_valid_phones;
            if ('bitrix_deal_config' in response &&
                'pipeline' in response.bitrix_deal_config &&
                'stage' in response.bitrix_deal_config)
                this.bitrixDealConfig = response.bitrix_deal_config;
            if ('piperun_deal_config' in response &&
                'pipeline' in response.piperun_deal_config &&
                'stage' in response.piperun_deal_config)
                this.piperunDealConfig = response.piperun_deal_config;
            if (response.selected_filters) {
                const { decisors, decisors_with, departments, levels, unique_decisors_only, } = response.selected_filters;
                this.filters.decisors = decisors;
                this.filters.decisors_with = decisors_with;
                this.filters.departments = departments;
                this.filters.levels = levels;
                this.filters.unique_decisors_only = unique_decisors_only || false;
                this.decisorsFilter = decisors || false;
                if (this.fields['Decisores'] !== undefined &&
                    this.fields['Decisores'] !== null) {
                    this.fields['Decisores'] = decisors || false;
                }
            }
            this.setExportType();
        }
        else {
            this.tab = 'excel';
            this.exportType = 'companies';
        }
        this.calculateExports();
        this.loaded = true;
    }
    disableExportButton() {
        return !!this.disableExportButtonMessage();
    }
    disableExportButtonMessage() {
        //@ts-ignore
        const { companies, decisors, emails, whatsapps } = this.exportStats;
        if (['excel', 'csv'].includes(this.tab) &&
            this.exportType == 'email' &&
            emails == 0) {
            return 'Não há e-mails para exportação';
        }
        if (['excel', 'csv'].includes(this.tab) &&
            this.exportType == 'whatsapp' &&
            whatsapps == 0) {
            return 'Não há whatsapps para exportação';
        }
        if (companies == 0) {
            return 'Não há empresas para exportação, revise os filtros aplicados';
        }
        if (['excel', 'csv'].includes(this.tab) &&
            this.exportType == 'decisors' &&
            decisors == 0) {
            return 'Não há decisores para exportação';
        }
        const exceedLimitDecisorsOrCompanies = exceedLimit(this.tab, companies, decisors, this.decisorsFilter);
        if (exceedLimitDecisorsOrCompanies) {
            return this.hanldeLimitMessage();
        }
        if (this.buttonLoading || this.calculatingCount > 0) {
            return 'Carregando...';
        }
    }
    hanldeLimitMessage() {
        let limit = '';
        switch (this.tab) {
            case 'excel':
                limit = '100.000 linhas';
                break;
            case 'agendor':
                limit = '1.500 registros';
                break;
            default:
                limit = '10.000 registros';
        }
        return `A quantidade de empresas ou decisores excedeu o limite de ${limit}. Que tal aumentar os critérios da sua busca?`;
    }
    getCompaniesStats() {
        //@ts-ignore
        return this.exportStats.companies;
    }
    getComponentType() {
        if (this.tab == 'excel' || this.tab == 'csv')
            return 'sheet';
        else
            return 'crm';
    }
    async destroyed() {
        if (!this.$route.params.infosetId) {
            // @ts-ignore
            this.actions.setCurrentInfosetByID('');
        }
    }
    handleClick() {
        if (!this.hasLoading[this.tab])
            this.exportClicked();
        else
            this.cancelExportation();
    }
    exportClicked() {
        this.handleMixpanelTracking('exportação externa: Iniciou uma exportação para CRM');
        this.btnClicked();
    }
    cancelExportation() {
        this.handleMixpanelTracking('exportação externa: Cancelou uma exportação para CRM');
        //@ts-ignore
        this.$refs.loadingProgress.btnClicked();
    }
    removeTabFromQueue(tab) {
        this.hasLoading = JSON.parse(JSON.stringify(this.hasLoading));
        delete this.hasLoading[tab];
    }
    addToLoadingQueue(tab, _id) {
        this.hasLoading = JSON.parse(JSON.stringify(this.hasLoading));
        this.hasLoading[tab] = _id;
    }
    trackingSuccessOnExportation() {
        this.loadingPercentageCompleted &&
            this.handleMixpanelTracking('exportação externa: Exportação para CRM foi bem sucedida');
    }
    // tracking
    handleMixpanelTracking(text) {
        return mixpanelTracking(text);
    }
    // InfosetExportContent methods
    getcalculateCompaniesOnTotvsFetching() {
        //@ts-ignore
        return this.calculateCompaniesOnTotvsFetching;
    }
    setCandenceApiUrl(candenceUrl) {
        this.cadenceApiUrl = candenceUrl;
    }
    setOwnerSelected(ownerSelected) {
        this.ownerSelected = ownerSelected;
    }
    updateFilterCompaniesStatus() {
        this.calculateExports();
    }
    changedOnlyValidPhonesFilter(value) {
        this.onlyValidPhones = value;
    }
    changeBitrixDealConfig(selectedOptions) {
        this.bitrixDealConfig = selectedOptions;
    }
    changePiperunDealConfig(selectedOptions) {
        this.piperunDealConfig = selectedOptions;
    }
    changeMeetimeCadenceConfig(selectedOptions) {
        this.meetimeCadenceConfig = selectedOptions;
    }
    async setSaveConfig(value) {
        this.saveFiltersAndFields = value;
        this.disabledToggleSaveFiltersAndFields = true;
        if (value) {
            await this.saveExportationFiltersAndFields();
        }
        else {
            //@ts-ignore
            await this.users.deleteExportationFieldsAndFiltersSaved();
        }
        this.disabledToggleSaveFiltersAndFields = false;
    }
    async calculateExistingCompaniesOnTotvs() {
        // @ts-ignore
        await this.actions.calculateExistingCompaniesOnTotvs({
            infosetId: this.infoset.id,
        });
    }
    setExportType() {
        if (this.service.includes('excel') || this.service.includes('csv')) {
            let type = this.service.split('-')[1] || 'companies';
            if (type === 'emails')
                type = 'email';
            if (type === 'whatsapps')
                type = 'whatsapp';
            this.exportType = type;
            this.service = this.service.split('-')[0] + '-' + type;
        }
    }
    checkAndSaveAppliedFilters() {
        if (this.saveFiltersAndFields && this.loaded) {
            if (this.saveTimeout) {
                clearTimeout(this.saveTimeout);
            }
            this.saveTimeout = setTimeout(() => {
                this.saveExportationFiltersAndFields();
            }, 500);
        }
    }
    onFiltersChange() {
        this.checkAndSaveAppliedFilters();
    }
    onFieldsChange() {
        this.checkAndSaveAppliedFilters();
    }
    onTabChangeForSave() {
        this.checkAndSaveAppliedFilters();
    }
    onServiceChangeForSave() {
        this.checkAndSaveAppliedFilters();
    }
    onOnlyValidPhonesChange() {
        this.checkAndSaveAppliedFilters();
    }
    onPiperunDealConfigChange() {
        this.checkAndSaveAppliedFilters();
    }
    onBitrixDealConfigChange() {
        this.checkAndSaveAppliedFilters();
    }
    async saveExportationFiltersAndFields() {
        const config = {
            current_tab: this.tab,
            service: this.service,
            fields: this.fields,
            filters: this.filters,
            only_valid_phones: this.onlyValidPhones,
            piperun_deal_config: this.piperunDealConfig,
            bitrix_deal_config: this.bitrixDealConfig,
        };
        //@ts-ignore
        await this.users.saveExportationFieldsAndFilters(config);
    }
    resetFilters() {
        this.filters.levels = [];
        this.filters.departments = [];
        this.filters.decisors_with = [];
    }
    manageFields(list) {
        const arr = {};
        list.map(el => {
            arr[el.name] = el.checkbox;
        });
        this.fields = arr;
    }
    manageLeads(leadStatus) {
        if (leadStatus) {
            this.fields['Status'] = leadStatus;
        }
        else {
            delete this.fields['Status'];
        }
    }
    async resetDecisorFilters(val, oldval) {
        if (['excel', 'csv'].includes(val)) {
            this.service = val + '-' + this.exportType;
        }
        else {
            this.service = val;
        }
        if (val === 'totvs') {
            await this.calculateExistingCompaniesOnTotvs();
        }
        if (['excel', 'csv'].includes(oldval) && ['excel', 'csv'].includes(val)) {
            return;
        }
        if (oldval != '') {
            this.resetFilters();
            this.exportType = 'companies';
        }
        this.calculateExports();
    }
    setServiceByExportType(val, oldval) {
        this.service = this.tab + '-' + val;
        if (oldval == 'decisors')
            this.resetFilters();
        this.calculateExports();
    }
    changedDecisorsFilter(value) {
        this.filters.decisors = value;
        this.filters.levels = [];
        this.filters.departments = [];
        this.filters.decisors_with = [];
        this.calculateExports();
        if (this.fields['Decisores'] !== undefined &&
            this.fields['Decisores'] !== null)
            this.fields['Decisores'] = value;
        this.decisorsFilter = value;
    }
    setBtnUpdateTotvsData({ updateTotvsData, companiesCNPJsTotvsExists, }) {
        this.updateTotvsData = updateTotvsData;
        this.companiesCNPJsTotvsExists = companiesCNPJsTotvsExists;
    }
    async calculateExports() {
        this.calculatingCount++;
        try {
            // @ts-ignore
            await this.actions.calculateExports({
                // @ts-ignore
                infosetId: this.infoset.id,
                payload: {
                    filters: this.filters,
                    service: this.service,
                },
            });
        }
        finally {
            this.calculatingCount--;
        }
    }
    async btnClicked() {
        const tab = this.tab;
        this.buttonLoading = true;
        if (this.saveFiltersAndFields) {
            this.saveExportationFiltersAndFields();
        }
        const payload = {
            service: this.service,
            filters: this.filters,
            fields: this.fields,
            keep_redundancy: this.keepRedundancy,
        };
        let result;
        switch (this.tab) {
            case 'excel':
            case 'csv':
                // @ts-ignore
                result = await this.actions.exportData({
                    infosetId: this.infoset.id,
                    infosetName: this.infoset.name,
                    payload,
                });
                break;
            case 'salesforce':
                // @ts-ignore
                result = await this.users.exportSalesForce({
                    infosetId: this.infoset.id,
                    payload,
                });
                break;
            case 'rdstation':
                // @ts-ignore
                result = await this.users.exportRDStation({
                    infosetId: this.infoset.id,
                    payload,
                });
                break;
            case 'pipedrive':
                // @ts-ignore
                result = await this.users.exportPipedrive({
                    infosetId: this.infoset.id,
                    payload,
                });
                break;
            case 'ploomes':
                // @ts-ignore
                result = await this.users.exportPloomes({
                    infosetId: this.infoset.id,
                    payload,
                });
                break;
            case 'hubspot':
                // @ts-ignore
                result = await this.users.exportHubspot({
                    infosetId: this.infoset.id,
                    payload,
                });
                break;
            case 'bitrix24':
                // @ts-ignore
                result = await this.users.exportBitrix24({
                    infosetId: this.infoset.id,
                    payload: {
                        ...payload,
                        dealConfig: this.bitrixDealConfig,
                    },
                });
                break;
            case 'agendor':
                // @ts-ignore
                result = await this.users.exportAgendor({
                    infosetId: this.infoset.id,
                    payload,
                });
                break;
            case 'piperun':
                // @ts-ignore
                result = await this.users.exportPiperun({
                    infosetId: this.infoset.id,
                    payload,
                    onlyValidPhones: this.onlyValidPhones,
                    dealConfig: this.piperunDealConfig,
                });
                break;
            case 'totvs':
                // @ts-ignore
                result = await this.users.exportToTvs({
                    infosetId: this.infoset.id,
                    payload: {
                        ...payload,
                        updateTotvsData: this.updateTotvsData,
                        companiesCNPJsTotvsExists: this.companiesCNPJsTotvsExists,
                    },
                });
                break;
            case 'funildevendas':
                // @ts-ignore
                result = await this.users.exportFunilDeVendas({
                    infosetId: this.infoset.id,
                    payload,
                });
                break;
            case 'zoho':
                // @ts-ignore
                result = await this.users.exportZoho({
                    infosetId: this.infoset.id,
                    payload,
                });
                break;
            case 'meetime':
                // @ts-ignore
                result = await this.users.exportMeetime({
                    infosetId: this.infoset.id,
                    payload,
                    cadenceConfig: this.meetimeCadenceConfig,
                    onlyValidPhones: this.onlyValidPhones,
                });
                break;
        }
        this.handleResult(result, tab);
    }
    handleResult(result, tab = '') {
        if (result && [200, 201].includes(result.status)) {
            NotificationService.success('Sucesso', result.data.message);
            if (this.tab !== 'salesforce') {
                this.addToLoadingQueue(tab, result.data.event._id);
            }
        }
        else {
            let message = 'Aconteceu algo inesperado e não foi possível exportar sua lista !';
            if (result && result.data) {
                if (result.data.description) {
                    message = result.data.description;
                    NotificationService.error('Erro', message);
                }
                else if (result.data.message) {
                    message = result.data.message;
                    NotificationService.error('Erro', message);
                }
                else if (result.data.title) {
                    message = result.data.title;
                    NotificationService.error('Erro', message);
                }
            }
        }
        this.buttonLoading = false;
    }
};
__decorate([
    PropSync('open', { default: false })
], InfosetExportModalContainer.prototype, "showModal", void 0);
__decorate([
    Prop({ default: () => { } })
], InfosetExportModalContainer.prototype, "infoset", void 0);
__decorate([
    Watch('loadingPercentageCompleted')
], InfosetExportModalContainer.prototype, "trackingSuccessOnExportation", null);
__decorate([
    Watch('filters.companiesSuccessStatus')
], InfosetExportModalContainer.prototype, "updateFilterCompaniesStatus", null);
__decorate([
    Watch('filters', { deep: true })
], InfosetExportModalContainer.prototype, "onFiltersChange", null);
__decorate([
    Watch('fields', { deep: true })
], InfosetExportModalContainer.prototype, "onFieldsChange", null);
__decorate([
    Watch('tab')
], InfosetExportModalContainer.prototype, "onTabChangeForSave", null);
__decorate([
    Watch('service')
], InfosetExportModalContainer.prototype, "onServiceChangeForSave", null);
__decorate([
    Watch('onlyValidPhones')
], InfosetExportModalContainer.prototype, "onOnlyValidPhonesChange", null);
__decorate([
    Watch('piperunDealConfig', { deep: true })
], InfosetExportModalContainer.prototype, "onPiperunDealConfigChange", null);
__decorate([
    Watch('bitrixDealConfig', { deep: true })
], InfosetExportModalContainer.prototype, "onBitrixDealConfigChange", null);
__decorate([
    Watch('tab')
], InfosetExportModalContainer.prototype, "resetDecisorFilters", null);
__decorate([
    Watch('exportType')
], InfosetExportModalContainer.prototype, "setServiceByExportType", null);
InfosetExportModalContainer = __decorate([
    Component(connect(({ actions, state }) => ({
        actions: actions.infosets,
        users: actions.users,
        exportStats: state.infosets.exportStats,
        calculateCompaniesOnTotvsFetching: state.users.calculateCompaniesOnTotvsFetching,
    }), {
        name: 'InfosetExportModalContainer',
        components: {
            Modal,
            InfosetExportTabs,
            Header,
            InfosetExportContentComponent,
            InnerLoading,
            InfosetExportProgressContainer,
            Tooltip,
        },
    }))
], InfosetExportModalContainer);
export default InfosetExportModalContainer;
